import {AppPageElement} from './app.page.element';
/**
 * 头部展示效果
 */
export class AppPageHead {
    /**
     * 模块名称
     */
    name: string;
    /**
     * 模块样式
     */
    class: string;
    /**
     * 文字展示
     */
    title: string;
    /**
     * 是否显示节点
     */
    isShow: boolean;
    /**
     * 模块列表
     */
    element: Array<AppPageElement> = new Array<AppPageElement>();
    /**
     * 当前element节点是否存在
     */
    elementListIsEmpty: boolean;
}